import React from 'react';

import { InboxVerifierStaff } from 'src/components/inbox';
import {
  ApproveVerificationRequestByVerifierModal,
  DeclineVerificationRequestByVerifierModal,
  ReverificationSubmitByVerifierStaffModal,
  VerificationRequestCreateByCommercialVerifierModal,
  VerificationRequestCreateByGovernmentVerifierModal,
} from 'src/modals/verificationRequest';
import { VerificationRequestFormProvider } from 'src/providers/VerificationRequestFormProvider';

export const InboxPageVerifierStaff: React.FC = () => {
  return (
    <React.Fragment>
      <InboxVerifierStaff />

      <VerificationRequestFormProvider>
        <VerificationRequestCreateByCommercialVerifierModal />
      </VerificationRequestFormProvider>

      <VerificationRequestFormProvider>
        <VerificationRequestCreateByGovernmentVerifierModal />
      </VerificationRequestFormProvider>

      <VerificationRequestFormProvider>
        <ReverificationSubmitByVerifierStaffModal />
      </VerificationRequestFormProvider>

      <ApproveVerificationRequestByVerifierModal />
      <DeclineVerificationRequestByVerifierModal />
    </React.Fragment>
  );
};
